const ACCOUNT_DRAWER_OPEN_EVENT = 'trashie:account-drawer-open';
const ACCOUNT_DRAWER_CLOSE_EVENT = 'trashie:account-drawer-close';
const ACCOUNT_DRAWER_STATE_EVENT = 'trashie:account-drawer-state';
/**
 * Opens the Account drawer on the Gift Cards panel. Optional
 * `detail: { initialDetailOrderId }` auto-opens the GiftCardDetailSheet for
 * that order on mount. Omitting detail opens the panel main view only.
 */
const ACCOUNT_DRAWER_SHOW_GIFT_CARDS_EVENT = 'trashie:account-drawer-show-gift-cards';
/** Opens the Account drawer on the Account Settings hub panel. */
const ACCOUNT_DRAWER_SHOW_ACCOUNT_SETTINGS_EVENT = 'trashie:account-drawer-show-account-settings';
const ACCOUNT_DRAWER_BACK_TO_ACCOUNT_EVENT = 'trashie:account-drawer-back-to-account';
const ACCOUNT_DRAWER_SHOW_TRANSACTIONS_EVENT = 'trashie:account-drawer-show-transactions';
/**
 * Opens the Account drawer on the "My Shipping Labels" (Take Back Bags) panel.
 * Optional `detail: { initialView, code, batchId }` deep-opens the detail/batch
 * sub-view; omitting detail opens the list view.
 */
const ACCOUNT_DRAWER_SHOW_TBB_EVENT = 'trashie:account-drawer-show-tbb';
/** Opens the Account drawer on the Membership "Delivery Address" panel. */
const ACCOUNT_DRAWER_SHOW_MEMBERSHIP_ADDRESSES_EVENT = 'trashie:account-drawer-show-membership-addresses';
/** sessionStorage key: open account drawer on notifications tab (value: `notifications`) */
const ACCOUNT_DRAWER_NOTIFICATIONS_TAB_SESSION_KEY = 'trashie:accountDrawerNotificationsTab';
const TRACKING_DRAWER_OPEN_EVENT = 'trashie:tracking-drawer-open';
const TRACKING_DRAWER_STATE_EVENT = 'trashie:tracking-drawer-state';
/** Fired by the global Header search pill on /deals and /deals/list to open RewardsSearchV2 */
const DEALS_SEARCH_OPEN_EVENT = 'trashie:deals-search-open';
/** Fired by the global Header search pill on /rewards to open RewardsSearchV2 (gift-cards mode) */
const REWARDS_SEARCH_OPEN_EVENT = 'trashie:rewards-search-open';
/**
 * Cancelable — Header back chevron dispatches this before navigating to the
 * parent route. Pages with in-route sub-flows (e.g. GiftCardBrand CONFIRM view)
 * can `preventDefault()` and handle back locally; otherwise Header falls through
 * to `history.push(parentRoute)`.
 */
const HEADER_BACK_INTERCEPT_EVENT = 'trashie:header-back-intercept';
/**
 * Pages can dispatch `{ detail: { hidden: boolean } }` to hide/show the global
 * Header back chevron independently of the route's ROUTES_TREE parent. Used when
 * a sub-flow locks the user in (e.g. GiftCardBrand CLAIM while processing/ready).
 * The flag clears on route change; pages should dispatch `{ hidden: false }` on
 * unmount if they set it.
 */
const HEADER_BACK_VISIBILITY_EVENT = 'trashie:header-back-visibility';

export {
  ACCOUNT_DRAWER_CLOSE_EVENT,
  ACCOUNT_DRAWER_NOTIFICATIONS_TAB_SESSION_KEY,
  ACCOUNT_DRAWER_STATE_EVENT,
  ACCOUNT_DRAWER_SHOW_GIFT_CARDS_EVENT,
  ACCOUNT_DRAWER_SHOW_ACCOUNT_SETTINGS_EVENT,
  ACCOUNT_DRAWER_BACK_TO_ACCOUNT_EVENT,
  ACCOUNT_DRAWER_SHOW_TRANSACTIONS_EVENT,
  ACCOUNT_DRAWER_SHOW_TBB_EVENT,
  ACCOUNT_DRAWER_SHOW_MEMBERSHIP_ADDRESSES_EVENT,
  TRACKING_DRAWER_OPEN_EVENT,
  TRACKING_DRAWER_STATE_EVENT,
  DEALS_SEARCH_OPEN_EVENT,
  REWARDS_SEARCH_OPEN_EVENT,
  HEADER_BACK_INTERCEPT_EVENT,
  HEADER_BACK_VISIBILITY_EVENT,
};
export default ACCOUNT_DRAWER_OPEN_EVENT;
